export const getChipSx = (options = {}) => {
  return options.isPrint
    ? {
        '& .MuiTypography-root': { fontSize: '0.5625rem' },
      }
    : {
        '& .MuiTypography-root': { fontWeight: 600, fontSize: '0.75rem' },
        '&:hover': {
          cursor: 'pointer',
        },
      };
};

export const findEventObject = (events, key, name) => {
  if (!Array.isArray(events)) {
    return null;
  }

  const match = events.find((event) => event[key] && event[key].name === name);

  return match ? match[key] : null;
};
